<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Giveaway Paket</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Giveaway Paket</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabgiveaway" data-toggle="tab">Giveaway Paket</a>
                                            </li>
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
                                        <!-- Giveaway Tab -->
										<div id="tabgiveaway" class="tab-pane fade show active">
											
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdl">Tambah Giveaway</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tbl" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="">Nama User</th>
                                                                    <th class="">Nama Paket</th>
                                                                    <th class="text-ceter">Tanggal Giveaway</th>
                                                                    <th class="text-center">No Invoice</th>
                                                                    <th class="text-center">Status</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstgiveaway" :key="ref.id_sales">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.namauser }}</td>
                                                                    <td>{{ ref.nama_paket }}</td>
                                                                    <td>{{ (ref.purchase_date!="0000-00-00 00:00:00")?ref.purchase_date:"-" }}</td>
                                                                    <td>{{ ref.external_id }}</td>
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.inv_status == 'PENDING' , 'bg-success-light' : ref.inv_status == 'PAID', 'bg-danger-light' : ref.inv_status == 'EXPIRED' }">{{ref.inv_status_nm}}</span>
                                                                        <!-- <span :class="{'alert-sm': true, 'alert-warning' : ref.inv_status_nm == 'PENDING' , 'alert-info' : ref.inv_status == 'SETTLED', 'alert-danger' : ref.inv_status == 'EXPIRED' }">{{ref.inv_status_nm}}</span> -->
                                                                    </td>
                                                                    <td>
                                                                        <template v-if="ref.inv_status == 'PAID'">
                                                                        <v-btn class="btn btn-sm bg-danger-light" depressed small @click="updateStsInvoice(ref)">
                                                                           Non Aktifkan
                                                                        </v-btn>
                                                                        </template>
                                                                        <template v-if="ref.inv_status == 'EXPIRED'">
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="updateStsInvoice(ref)">
                                                                           Aktifkan
                                                                        </v-btn>
                                                                        </template>
                                                                    </td>
                                                                  
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
                                            
										</div>
                                        <!-- /Giveaway Tab -->
										
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <!-- ---------- -->
        <div id="addMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Giveaway Paket</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Pilih User <span class="text-danger">*</span></label>
                                <v-select
                                :options="lstuser"
                                :reduce="lstuser => lstuser.id_user" 
                                label="email"
                                v-model="giveaway.id_user"
                                @input="getAllPaket"
                                />                              
                            </div>
                            <div class="form-group">
                                <label>Pilih Paket <span class="text-danger">*</span></label>
                                <v-select
                                :options="lstpaket"
                                :reduce="lstpaket => lstpaket.id_paket" 
                                label="nama_paket"
                                v-model="giveaway.id_paket"
                                />                              
                            </div>
                            <!-- <div class="form-group">
                                <label>Nama Materi <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="materi.nama_materi">
                            </div> -->
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="save">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- <div id="delMdlGiveaway" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus materi <b>{{ materi.nama_materi }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapusMateri">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div> -->

    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'Giveaway',
    // vuetify: new Vuetify(),
    data() {
        return {
            lstuser: [],
            lstpaket: [],
            lstgiveaway: [],
            giveaway:{
                id_sales: '',
                id_paket: '',
                id_user: '',
                // id_user: '',
                // id_user: '',
                // id_user: '',
                // id_user: '',
            },
        }
    },
    created: function () {
        this.getAll();
        this.getAllUser();
        // this.getAllPaket();
    },  

    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
                });
               }, 300)
               
                
        },
      
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        reloadTbl(tbId){

            // dT.destroy();
            $('#'+tbId).DataTable();
            $('#'+tbId).destroy();
            this.initDt('#'+tbId);
            // $('#'+tbId).ajax.reload();
        },

        refreshAll(){
            this.getAll();
        },
        
        // Get List User
        getAllUser: function () {
            axios.get('api/lstuserbyhakakses/1')
                .then(res => {
                    this.lstuser = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get List User
        getAllPaket: function () {
            axios.get('api/paketforgiveaway/'+this.giveaway.id_user)
                .then(res => {
                    this.lstpaket = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Get Giveaway
        getAll: function () {
            axios.get('api/transaksigiveaway')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tbl");
                    this.lstgiveaway = res.data.data;
                    this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New product
        save: function () {
            swal.fire({
				title: "Tambah Giveaway?",
				text: "Apakah anda yakin akan memberikan giveaway ini?",
				icon: "warning",
				buttons: true,
				dangerMode: true,
                showDenyButton: true,  showCancelButton: true,  
                confirmButtonText: `Simpan`,  
                denyButtonText: `Tidak`,
            })
            .then((res) => {
                if (res.value) {                    
                    this.loading = true;
                    this.external_id = "INV-"+Date.now();
                    if(this.giveaway.id_paket && this.giveaway.id_user){
                        axios.post('api/invoicegiveaway', {
                            id_user: this.giveaway.id_user,
                            id_paket: this.giveaway.id_paket,
                            external_id: this.external_id
                        })
                        .then(res => {
                            // handle success
                            // localStorage.removeItem('idPaket');
                            // localStorage.setItem("idPaket",  res.data.data); 
                            this.loading = false;
                            swal.fire("Giveaway berhasil ditambahkan!", {
                                icon: "success",
                            });
                            this.getAll();
                            this.resetVar();
                            $("#addMdl").modal('hide');
                            // if(parseInt(this.paket.harga_aktif) >0)
                            // 	this.$router.push({name:'siswa-paket-belajar-invoice'});//, params: {id: res.data.data}}); 
                            // else
                            // 	this.$router.push({name:'siswa-paket-belajar-invoice-gratis'});//, params: {id: res.data.data}}); 
                                
                            
                        })
                        .catch(err => {
                            // handle error
                            console.log(err);
                            this.loading = false;
                            swal("Giveaway gagal ditambahkan");

                        })
                    }  
                    
                } else {
                    this.resetVar();
                    $("#addMdl").modal('hide');
                }
            })


                      
        },

        updateStsInvoice: function (ref) {
            var stsMsg = (ref.inv_status == 'PAID')?"non":"";
            swal.fire({
				title: "Update Status Giveaway",
				text: "Apakah anda yakin akan me"+stsMsg+"aktifkan giveaway ini?",
				icon: "warning",
				buttons: true,
				dangerMode: true,
                showDenyButton: true,  showCancelButton: true,  
                confirmButtonText: `Ya`,  
                denyButtonText: `Tidak`,
            })
            .then((res) => {
                if (res.value) {                  
                        var sts = (ref.inv_status == 'PAID')?"EXPIRED":"PAID";
                        axios.post('api/ststransaksigiveaway', {
                            id_sales: ref.id_sales,
                            status: sts
                        })
                        .then(res => {
                            
                            swal.fire("Giveaway berhasil di"+stsMsg+"aktifkan!", {
                                icon: "success",
                            });
                            this.getAll();
                             
                            
                        })
                        .catch(err => {
                            // handle error
                            console.log(err);
                            swal("Giveaway gagal di"+stsMsg+"aktifkan");

                        })
                    
                    
                } else {
                    $("#addMdl").modal('hide');
                }
            })


                      
        },

        resetVar: function(ref){
            // if(ref){
            //     this.giveaway.id_tingkatan = ref.id_tingkatan;
            //     this.tingkatan.nama_tingkatan = ref.nama_tingkatan;
            // } else {
                this.giveaway.id_paket = '';
                this.giveaway.id_user = '';
            // }
        },

        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        // Delete Product
        hapus: function () {
            axios.post('api/reftingkatandel', {
                    id_tingkatan: this.tingkatan.id_tingkatan,
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#delMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        //--------------------------
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Giveaway/index.vue